import { useEffect } from "react";
import { Outlet, useParams } from "react-router";
import { useAtom, useAtomValue } from "jotai";
import { Division, Flex, Heading, Span } from "@ir/ui";
import LoadingSpinner from "@/presentation/ui/components/common/LoadingSpinner";
import {
  fetchShareLinkAtom,
  resetShareLinkAtom,
  shareLinkDataAtom,
  shareLinkStatusAtom,
} from "@/store/shareLink";
import LogoCompact from "@/presentation/ui/svg/logo-compact";
import { DateService } from "@/core/services/Date.service";
import { DateAdapter } from "@/infrastructure/adapters/dayJs";
import "@/presentation/pages/analytics/styles/Analytics.page.scss";

const dateService = new DateService(new DateAdapter());

const ShareLinkLayout = () => {
  const { token: routeToken } = useParams<{ resourceSlug: string; token: string }>();
  const status = useAtomValue(shareLinkStatusAtom);
  const shareLink = useAtomValue(shareLinkDataAtom);
  const [, fetchShareLink] = useAtom(fetchShareLinkAtom);
  const [, resetShareLink] = useAtom(resetShareLinkAtom);

  const token = routeToken ?? "";

  useEffect(() => {
    if (!token) return;
    void fetchShareLink(token);
    return () => {
      resetShareLink();
    };
  }, [token, fetchShareLink, resetShareLink]);

  return (
    <Division className="min-vh-100 bg-white">
      <Flex
        className="share-link-layout-header border-bottom-1 border-color-grey-25 px-4 py-2"
        gap={1}
        align="center"
        justifyContent="space-between"
      >
        <Flex align="center" gap={1} wrap="wrap">
          <LogoCompact />
          <Heading text="Analytics" level={6} className="m-0 font-bold text-grey-600" />
        </Flex>
        <Span className="share-link-layout-expiry text-sm text-grey-600 text-right">
          <Span className="small">Expires in</Span> <br /> <Span className="font-bold text-grey-700">{shareLink?.expiresAt ? dateService.timeUntil(shareLink.expiresAt) : ""}</Span>
        </Span>
      </Flex>
      {status === "loading" || status === "idle" ? <LoadingSpinner /> : <Outlet />}
    </Division>
  );
};

export default ShareLinkLayout;
